import React, { useCallback } from "react"
import { Button, OverlayTrigger, Popover } from "react-bootstrap"

import { getFormattedMessage } from "../../../../components/shared_components_registration"

export default function FontSizeAdjuster({ intl, fontPercent, setFontPercent, disabled = false }) {
  const adjustFontSize = useCallback((e) => {
    e.preventDefault()
    let val = e.target.value
    if (val && val < 45) {
      val = 45
    } else if (val && val > 125) {
      val = 125
    }
    setFontPercent(val)
  }, [])

  return (
    <OverlayTrigger
      trigger="click"
      placement="left"
      rootClose
      overlay={
        <Popover id="metricsFontSize">
          <Popover.Body>
            <input
              type={"number"}
              onWheel={(e) => e.target.blur()}
              step={"1"}
              min={"25"}
              max={"200"}
              className={"text-center"}
              style={{ width: "50px" }}
              value={fontPercent}
              disabled={disabled}
              onChange={adjustFontSize}
            />
          </Popover.Body>
        </Popover>
      }
    >
      <Button
        variant={"outline-primary"}
        className={"btn btn-sm"}
        disabled={disabled}
        title={getFormattedMessage("general.adjust.text.size", "Adjust text size", true, intl)}
        onClick={(e) => e.preventDefault()}
      >
        <span className={"fa fa-font"} />
      </Button>
    </OverlayTrigger>
  )
}
